import { SeoHead } from "../components/common/SeoHead";
import { BlogList } from "../components/blog/BlogList";
import { Reveal } from "../components/common/Reveal";

export default function ConsultingInsights() {
  return (
    <main data-testid="consulting-insights">
      <SeoHead
        title="Insights — Coffee With Dr. Irma · Growth | iINSPIRE Consulting"
        description="Essays and articles on entrepreneurship, business growth, leadership, human capital and life — by Dr. Irma."
        path="/consulting/insights"
      />
      <section className="bg-warmwhite py-24 lg:py-32">
        <div className="container-site">
          <Reveal>
            <p className="eyebrow">Coffee With Dr. Irma · Growth</p>
            <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight text-ink sm:text-5xl">
              Insights for <span className="italic text-burgundy">builders.</span>
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/75 sm:text-lg">
              Entrepreneurship · Business · Leadership · Human Capital · Life.
            </p>
          </Reveal>
          <BlogList vertical="consulting" channel="coffee-growth" basePath="/consulting/insights" testId="insights-list" />
        </div>
      </section>
    </main>
  );
}
